export function isValidGuid(value: string | null | undefined): boolean {
  if (!value) return false;

  const emptyGuid = '00000000-0000-0000-0000-000000000000';
  if (value === emptyGuid) return false;

  // Permite guiones o sin guiones (32 o 36 chars)
  const regex =
    /^[0-9a-fA-F]{8}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{12}$/;

  return regex.test(value);
}
